import React from 'react';
import PageBanner from "@/components/pageBanner";

const Register = () => {
    return (
        <>
            <PageBanner title="Register"/>
            <section className="generic-container py-14">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam non enim euismod, pulvinar diam ut,
                    mattis metus. Aliquam eu nisl ante. Fusce eget ex quis risus gravida laoreet. Curabitur velit nisl,
                    pretium hendrerit metus quis, commodo mattis libero. Phasellus tincidunt pretium scelerisque. Aenean
                    id velit in ipsum venenatis malesuada ac in nisi. Curabitur vitae vulputate nulla. Etiam dolor
                    risus, pharetra at viverra nec, hendrerit at dui. Fusce consequat feugiat suscipit. Cras et sodales
                    lectus. Integer ultricies commodo odio, eu ornare massa.</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam non enim euismod, pulvinar diam ut,
                    mattis metus. Aliquam eu nisl ante. Fusce eget ex quis risus gravida laoreet. Curabitur velit nisl,
                    pretium hendrerit metus quis, commodo mattis libero. Phasellus tincidunt pretium scelerisque. Aenean
                    id velit in ipsum venenatis malesuada ac in nisi. Curabitur vitae vulputate nulla. Etiam dolor
                    risus, pharetra at viverra nec, hendrerit at dui. Fusce consequat feugiat suscipit. Cras et sodales
                    lectus. Integer ultricies commodo odio, eu ornare massa.</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam non enim euismod, pulvinar diam ut,
                    mattis metus. Aliquam eu nisl ante. Fusce eget ex quis risus gravida laoreet. Curabitur velit nisl,
                    pretium hendrerit metus quis, commodo mattis libero. Phasellus tincidunt pretium scelerisque. Aenean
                    id velit in ipsum venenatis malesuada ac in nisi. Curabitur vitae vulputate nulla. Etiam dolor
                    risus, pharetra at viverra nec, hendrerit at dui. Fusce consequat feugiat suscipit. Cras et sodales
                    lectus. Integer ultricies commodo odio, eu ornare massa.</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam non enim euismod, pulvinar diam ut,
                    mattis metus. Aliquam eu nisl ante. Fusce eget ex quis risus gravida laoreet. Curabitur velit nisl,
                    pretium hendrerit metus quis, commodo mattis libero. Phasellus tincidunt pretium scelerisque. Aenean
                    id velit in ipsum venenatis malesuada ac in nisi. Curabitur vitae vulputate nulla. Etiam dolor
                    risus, pharetra at viverra nec, hendrerit at dui. Fusce consequat feugiat suscipit. Cras et sodales
                    lectus. Integer ultricies commodo odio, eu ornare massa.</p>
            </section>
        </>
    );
};

export default Register;